// extracted by mini-css-extract-plugin
module.exports = {"lineBottom":"Recognition_lineBottom__sj1xJ","recognitions":"Recognition_recognitions__pYoxw","RegLogo":"Recognition_RegLogo__JPdxn"};